import React from "react";
import CheckoutModal from "./CheckoutModal";
import { useCheckout } from "../context/CheckoutContext";
import { useScrollLock } from "../hooks/useScrollLock";

const CheckoutModalWrapper = () => {
  const { isOpen, type, closeCheckout } = useCheckout();

  useScrollLock(isOpen);

  return (
    <CheckoutModal
      isOpen={isOpen}
      onClose={closeCheckout}
      checkoutType={type}
    />
  );
};

export default CheckoutModalWrapper;
